import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import i18n from "../../i18n";
import { getExpiringLicenses } from "../../api/licenseAdminApi";

export default function LicenseExpiryNotice() {
  const accessToken = useSelector((state) => state.session?.accessToken);
  const [licenses, setLicenses] = useState([]);

  useEffect(() => {
    if (!accessToken) return undefined;
    let active = true;
    setLicenses([]);
    const load = () => getExpiringLicenses(accessToken)
      .then((items) => { if (active) setLicenses(items); })
      .catch((error) => { if (active) console.error("Could not load licence expiry warnings", error); });
    load();
    const timer = window.setInterval(load, 15 * 60 * 1000);
    return () => { active = false; window.clearInterval(timer); };
  }, [accessToken]);

  const expiryKey = licenses.map((license) => `${license.edge_id}:${license.days_remaining}`).join("|");
  useEffect(() => {
    if (!licenses.length) return;
    toast.warning(i18n.t("edgeDetail.license.expiring", { n: licenses.length }));
  }, [expiryKey]);

  return null;
}
